import React from 'react';

const STEPS = [
  { n: 1, title: 'Scan the Barcode', body: 'Use your phone camera or type the barcode manually' },
  { n: 2, title: 'See All 4 Prices Instantly', body: 'Flipping Friends checks all 4 major platforms in real-time' },
  { n: 3, title: 'Sell to the Highest Bidder', body: 'We highlight the best offer. You make the sale. Pocket the difference.' },
];

export default function SolutionSection() {
  return (
    <section className="py-24 md:py-32 px-4 sm:px-6 lg:px-8 bg-[#050505]" data-testid="solution-section">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-white mb-4 tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
          One Scan. Four Buyers. Best Price. Always.
        </h2>
        <p className="text-center text-zinc-400 mb-12 text-lg">How It Works</p>
        <div className="grid md:grid-cols-3 gap-12">
          {STEPS.map((s) => (
            <div key={s.n} className="text-center">
              <div className="bg-gradient-to-r from-[#00D26A] to-[#FFD700] text-black w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold shadow-[0_0_20px_rgba(0,210,106,0.2)]">
                {s.n}
              </div>
              <h3 className="text-xl font-semibold text-white mb-3">{s.title}</h3>
              <p className="text-zinc-400 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
